import { Bookmark, BookmarkCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function SaveButton({ kind, slug, label = true, className = "" }) {
  const { isSaved, toggleSave, user } = useAuth();
  const on = isSaved(kind, slug);
  return (
    <button
      onClick={(e) => { e.stopPropagation(); toggleSave(kind, slug); }}
      className={`inline-flex items-center gap-2 f-mono text-xs uppercase tracking-[0.15em] hover:text-[var(--signal)] transition-colors ${on ? "text-[var(--signal)]" : "text-[#cfcec8]"} ${className}`}
      aria-label={on ? "Remove from saved" : "Save"}
      title={user ? "" : "Sign in to save"}
      data-testid={`save-${kind}-${slug}`}
    >
      {on ? <BookmarkCheck size={15} /> : <Bookmark size={15} />}
      {label && (on ? "Saved" : "Save")}
    </button>
  );
}
